import { getToken } from "js/formatting/getToken";
import config from "config/config";
export async function UpdatePaymentFrequency(payload) {
  let options = {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(payload),
  };
  const response = await fetch(
    `${config.REG_API_BASE_URL}/Payment/frequency`,
    options
  );
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
